$(document).ready(function () {
    if (window.matchMedia('(max-width: 1023px)').matches) {
        $(document).on('click', 'li[data-main-menu] .icon', function (event) {
            event.preventDefault()
            var thisElement = $(this).closest('li')
            var menuHandle = $(this).closest('li').data('main-menu')
            $(document)
                .find('[data-submenu]')
                .each(function () {
                    var subHandle = $(this).data('submenu')
                    if (subHandle === menuHandle) {
                        if ($(this).hasClass('item-active')) {
                            $(this).slideUp().removeClass('item-active')
                            thisElement.removeClass('item-active')
                        } else {
                            thisElement.addClass('item-active')
                            $(this).slideDown().addClass('item-active')
                        }
                    }
                })
            return false
        })
    } else {
        $('.itg-left-menu').hover(function () {
            var thisHandle = $(this).data('handle')
            var parentDiv = $(this).parent('#custom-mega-menu')
            parentDiv.find('.itg-left-menu').removeClass('active')
            $(this).addClass('active')
            var thisElement = $(this)
            parentDiv.find('.babymenu-drop').each(function () {
                var dropHandle = $(this).data('handle')
                if (dropHandle == thisHandle) {
                    $(this).addClass('active')
                } else {
                    $(this).removeClass('active')
                }
            })
        })
    }
    var deliverySuccess = $(document).find('body').data('delivery-success')
    var deliveryError = $(document).find('body').data('delivery-error')

    if (
        $(document).find('[data-shipping-id]').length ||
        $(document).find('[data-shipping-item-id]').length
    ) {
        var variantArray = []
        $(document)
            .find('[data-shipping-id]')
            .each(function () {
                var variantId = $(this).data('shipping-id')
                variantArray.push(variantId)
            })
        $(document)
            .find('[data-shipping-item-id]')
            .each(function () {
                var variantId = $(this).data('shipping-item-id')
                variantArray.push(variantId)
            })
        if (
            variantArray.length > 0 &&
            $(document).find('.shipping-available-location-name').length
        ) {
            var shippingFromLocation = $(document)
                .find('.shipping-available-location-name')
                .data('location-name')
                .toString()
            var checkFinalArray = []
            Shopify.shipping = variantArray
            Shopify.shippingAlong = function () {
                if (Shopify.shipping.length) {
                    var variantId = Shopify.shipping.shift()
                    var checkFinalArrayInner = {}
                    const variantSectionUrl =
                        '/variants/' +
                        variantId +
                        '/?section_id=helper-pickup-availability-extended'
                    fetch(variantSectionUrl)
                        .then((response) => response.text())
                        .then((text) => {
                            const sectionInnerHTML = new DOMParser()
                                .parseFromString(text, 'text/html')
                                .querySelector('.shopify-section')
                            var variantId = $(sectionInnerHTML)
                                .find('#variant-availability')
                                .data('variant-id')
                            var variantLocationAvailability = $(
                                sectionInnerHTML
                            )
                                .find('#variant-availability')
                                .data('location')
                                .toString()
                            checkFinalArrayInner['variant-id'] = variantId
                            var checkQty = 'false'
                            if (shippingFromLocation.indexOf(',') != -1) {
                                var splitLocation =
                                    shippingFromLocation.split(',')
                                splitLocation.forEach(function (locationName) {
                                    if (
                                        variantLocationAvailability.indexOf(
                                            locationName
                                        ) != -1
                                    ) {
                                        checkQty = 'true'
                                    }
                                })
                            } else {
                                if (
                                    variantLocationAvailability.indexOf(
                                        shippingFromLocation
                                    ) != -1
                                ) {
                                    checkQty = 'true'
                                }
                            }
                            checkFinalArrayInner['available'] = checkQty
                            checkFinalArray.push(checkFinalArrayInner)
                            Shopify.shippingAlong()
                        })
                } else {
                    var convertFinalArrayStringify =
                        JSON.stringify(checkFinalArray)
                    $(document)
                        .find('body')
                        .append(
                            '<script id="itg-shipping-availability">' +
                                convertFinalArrayStringify +
                                '</script>'
                        )
                    $(document)
                        .find('[data-shipping-id]')
                        .each(function () {
                            var thisVariantId = $(this).data('shipping-id')
                            var thisElement = $(this)
                            var thisDrawer = $(this).data('drawer')
                            checkFinalArray.forEach(function (variantData) {
                                if (
                                    thisVariantId === variantData['variant-id']
                                ) {
                                    if (variantData['available'] === 'true') {
                                        if (thisDrawer === true) {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--error unavailable-delivery'
                                                )
                                                .addClass('alert--success')
                                        } else {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--error unavailable-delivery'
                                                )
                                                .addClass('alert--success')
                                                .text(deliverySuccess)
                                        }
                                    } else {
                                        if (thisDrawer === true) {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--success'
                                                )
                                                .addClass(
                                                    'alert--error unavailable-delivery'
                                                )
                                        } else {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--success'
                                                )
                                                .addClass(
                                                    'alert--error unavailable-delivery'
                                                )
                                                .text(deliveryError)
                                        }
                                    }
                                }
                            })
                        })
                }
            }
            Shopify.shippingAlong()
        }
    }

    if (
        $(document).find('[data-list-shipping-id]').length &&
        $(document).find('.shipping-available-location-name').length
    ) {
        var shippingFromLocation = $(document)
            .find('.shipping-available-location-name')
            .data('location-name')
            .toString()
        var variantItemsArray = []
        $(document)
            .find('[data-list-shipping-id]')
            .each(function (index) {
                var variantId = $(this).data('list-shipping-id')
                var productId = $(this).data('product-id')
                variantItemsArray[index] = []
                variantItemsArray[index]['product-id'] = productId
                variantItemsArray[index]['variant-id'] = variantId
            })
        if (variantItemsArray.length > 0) {
            Shopify.queue = []
            for (var i = 0; i < variantItemsArray.length; i++) {
                product = variantItemsArray[i]['product-id']
                variant = variantItemsArray[i]['variant-id']
                Shopify.queue.push({
                    productId: product,
                    variantId: variant,
                })
            }
        }
        Shopify.moveAlong = function () {
            if (Shopify.queue.length) {
                var request = Shopify.queue.shift()
                var dataproductId = request.productId
                var dataVariantId = request.variantId.toString()
                if (dataVariantId.indexOf(',') != -1) {
                    Shopify.queueInner = []
                    var newArray = dataVariantId.split(',')
                    for (var i = 0; i < newArray.length; i++) {
                        Shopify.queueInner.push({
                            variantId: newArray[i],
                        })
                    }
                    var counterCheckQty = 'false'
                    Shopify.moveInnerAlong = function () {
                        if (Shopify.queueInner.length) {
                            var request = Shopify.queueInner.shift()
                            var dataVariant = request.variantId
                            const variantSectionUrl =
                                '/variants/' +
                                dataVariant +
                                '/?section_id=helper-pickup-availability-extended'
                            fetch(variantSectionUrl)
                                .then((response) => response.text())
                                .then((text) => {
                                    var checkFinalArray = []
                                    var checkFinalArrayInner = {}
                                    const sectionInnerHTML = new DOMParser()
                                        .parseFromString(text, 'text/html')
                                        .querySelector('.shopify-section')
                                    var variantId = $(sectionInnerHTML)
                                        .find('#variant-availability')
                                        .data('variant-id')
                                    var variantLocationAvailability = $(
                                        sectionInnerHTML
                                    )
                                        .find('#variant-availability')
                                        .data('location')
                                        .toString()
                                    checkFinalArrayInner['variant-id'] =
                                        variantId
                                    var checkQty = 'false'
                                    if (
                                        shippingFromLocation.indexOf(',') != -1
                                    ) {
                                        var splitLocation =
                                            shippingFromLocation.split(',')
                                        splitLocation.forEach(
                                            function (locationName) {
                                                if (
                                                    variantLocationAvailability.indexOf(
                                                        locationName
                                                    ) != -1
                                                ) {
                                                    checkQty = 'true'
                                                    counterCheckQty = 'true'
                                                }
                                            }
                                        )
                                    } else {
                                        if (
                                            variantLocationAvailability.indexOf(
                                                shippingFromLocation
                                            ) != -1
                                        ) {
                                            checkQty = 'true'
                                            counterCheckQty = 'true'
                                        }
                                    }
                                    checkFinalArrayInner['available'] = checkQty
                                    checkFinalArray.push(checkFinalArrayInner)
                                    if (
                                        $(document).find(
                                            '#itg-item-shipping-availability'
                                        ).length
                                    ) {
                                        var getItemScript = $(document)
                                            .find(
                                                '#itg-item-shipping-availability'
                                            )
                                            .html()
                                        var getFinalArray =
                                            JSON.parse(getItemScript)
                                        var finalArrayLength =
                                            getFinalArray.length
                                        finalArrayLength = finalArrayLength - 1
                                        checkFinalArray.forEach(
                                            function (variantData) {
                                                finalArrayLength =
                                                    finalArrayLength + 1
                                                getFinalArray[
                                                    finalArrayLength
                                                ] = {}
                                                getFinalArray[finalArrayLength][
                                                    'variant-id'
                                                ] = variantData['variant-id']
                                                getFinalArray[finalArrayLength][
                                                    'available'
                                                ] = variantData['available']
                                            }
                                        )
                                        var convertFinalArrayStringify =
                                            JSON.stringify(getFinalArray)
                                        $(document)
                                            .find(
                                                '#itg-item-shipping-availability'
                                            )
                                            .empty()
                                            .append(convertFinalArrayStringify)
                                    } else {
                                        var convertFinalArrayStringify =
                                            JSON.stringify(checkFinalArray)
                                        $(document)
                                            .find('body')
                                            .append(
                                                '<script id="itg-item-shipping-availability">' +
                                                    convertFinalArrayStringify +
                                                    '</script>'
                                            )
                                    }
                                    Shopify.moveInnerAlong()
                                })
                        } else {
                            if (counterCheckQty == 'true') {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--error unavailable-delivery'
                                    )
                                    .addClass('alert--success')
                                    .text(deliverySuccess)
                            } else {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--success'
                                    )
                                    .addClass(
                                        'alert--error unavailable-delivery'
                                    )
                                    .text(deliveryError)
                            }
                            counterCheckQty = 'false'
                            Shopify.moveAlong()
                        }
                    }
                    Shopify.moveInnerAlong()
                } else {
                    const variantSectionUrl =
                        '/variants/' +
                        dataVariantId +
                        '/?section_id=helper-pickup-availability-extended'
                    fetch(variantSectionUrl)
                        .then((response) => response.text())
                        .then((text) => {
                            var checkFinalArray = []
                            var checkFinalArrayInner = {}
                            const sectionInnerHTML = new DOMParser()
                                .parseFromString(text, 'text/html')
                                .querySelector('.shopify-section')
                            var variantId = $(sectionInnerHTML)
                                .find('#variant-availability')
                                .data('variant-id')
                            var variantLocationAvailability = $(
                                sectionInnerHTML
                            )
                                .find('#variant-availability')
                                .data('location')
                                .toString()
                            checkFinalArrayInner['variant-id'] = variantId
                            var checkQty = 'false'
                            if (shippingFromLocation.indexOf(',') != -1) {
                                var splitLocation =
                                    shippingFromLocation.split(',')
                                splitLocation.forEach(function (locationName) {
                                    if (
                                        variantLocationAvailability.indexOf(
                                            locationName
                                        ) != -1
                                    ) {
                                        checkQty = 'true'
                                    }
                                })
                            } else {
                                if (
                                    variantLocationAvailability.indexOf(
                                        shippingFromLocation
                                    ) != -1
                                ) {
                                    checkQty = 'true'
                                }
                            }
                            checkFinalArrayInner['available'] = checkQty
                            checkFinalArray.push(checkFinalArrayInner)
                            if (
                                $(document).find(
                                    '#itg-item-shipping-availability'
                                ).length
                            ) {
                                var getItemScript = $(document)
                                    .find('#itg-item-shipping-availability')
                                    .html()
                                var getFinalArray = JSON.parse(getItemScript)
                                var finalArrayLength = getFinalArray.length
                                finalArrayLength = finalArrayLength - 1
                                checkFinalArray.forEach(function (variantData) {
                                    finalArrayLength = finalArrayLength + 1
                                    getFinalArray[finalArrayLength] = {}
                                    getFinalArray[finalArrayLength][
                                        'variant-id'
                                    ] = variantData['variant-id']
                                    getFinalArray[finalArrayLength][
                                        'available'
                                    ] = variantData['available']
                                })
                                var convertFinalArrayStringify =
                                    JSON.stringify(getFinalArray)
                                $(document)
                                    .find('#itg-item-shipping-availability')
                                    .empty()
                                    .append(convertFinalArrayStringify)
                            } else {
                                var convertFinalArrayStringify =
                                    JSON.stringify(checkFinalArray)
                                $(document)
                                    .find('body')
                                    .append(
                                        '<script id="itg-item-shipping-availability">' +
                                            convertFinalArrayStringify +
                                            '</script>'
                                    )
                            }
                            if (checkQty == 'true') {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--error unavailable-delivery'
                                    )
                                    .addClass('alert--success')
                                    .text(deliverySuccess)
                            } else {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--success'
                                    )
                                    .addClass(
                                        'alert--error unavailable-delivery'
                                    )
                                    .text(deliveryError)
                            }
                            Shopify.moveAlong()
                        })
                }
            }
        }
        Shopify.moveAlong()
    }
})
setInterval(function () {
    $(document)
        .find('.product-item__text,.product-text')
        .removeClass('disable-addbtn')
    $(document)
        .find('.shipping-indicator-card')
        .find('.unavailable-delivery')
        .each(function () {
            var checkAvaileblity = $(this)
                .next('pickup-availability-compact')
                .find('#change-store')
                .data('available')
            if (checkAvaileblity == false) {
                $(this)
                    .parents('.product-item__text')
                    .addClass('disable-addbtn')
            } else {
                $(this)
                    .parents('.product-item__text')
                    .removeClass('disable-addbtn')
            }
        })
    $(document)
        .find('.itg-ship-pickup')
        .find('.unavailable-delivery')
        .each(function () {
            var checkAvaileblity = $(this)
                .next('pickup-availability-compact')
                .find('#change-store')
                .data('available')
            if (checkAvaileblity == false) {
                $(this).parents('.product-text').addClass('disable-addbtn')
            } else {
                $(this).parents('.product-text').removeClass('disable-addbtn')
            }
        })
}, 1000)

$(document).on('click', '#change-store', function () {
    $(document).find('#site-store-selector-handle').trigger('click')
})
